/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

const base = {
    loaded: false,
    context: [
        'owner',
        'editor',
        'viewer'
    ],
    activity: {
        data: [],
        meta: {}
    },
    topUsers: [],
    histogram: {
        type: 'day',
        options: [
            { key: 'week', label: 'By Week', format: 'W' },
            { key: 'day', label: 'By Day', format: 'M/D/YYYY' },
            { key: 'month', label: 'By Month', format: 'MMM' },
            { key: 'year', label: 'By Year', format: 'YYYY' },
            { key: 'hour', label: 'By Hour', format: 'h:ms a' },
            { key: 'minute', label: 'By Minute', format: 'm' },
            { key: 'second', label: 'By Second', format: 's' }
        ],
        data: {}
    },
    geolocation: []
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(base)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/activity/state.js